import React, { useState } from 'react';

const CopyableUrlField = ({ label, value, fieldKey }) => {
  const [copiedField, setCopiedField] = useState(null);

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedField(fieldKey);
      setTimeout(() => setCopiedField(null), 1500);
    });
  };

  if (!value) return null;

  return (
    <>
      <label>{label}</label>
      {copiedField === fieldKey && (
        <small className="text-success float-right text-capitalize">
          {fieldKey} ✔ Copied
        </small>
      )}
      <div className="input-group align-items-center">
        <button
          type="button"
          className="btn btn-light btn-sm"
          style={{ border: "1px solid #dee2e6", padding: "4px 10px 5px" }}
          onClick={() => handleCopy(value)}
          title={`Copy ${label}`}
        >
          <img
            src="https://cdn-icons-png.flaticon.com/512/60/60990.png"
            alt="copy"
            width="16"
            height="16"
          />
        </button>
        <input
          type="text"
          name={fieldKey}
          className="form-control form-control-sm"
          value={value}
          readOnly
        />
      </div>
    </>
  );
};

export default CopyableUrlField;
